import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { installCallClickTracking } from './lib/trackCallClicks';

installCallClickTracking();

const container = document.getElementById('root')!;

const app = (
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
          <Toaster position="top-right" />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </StrictMode>
);

// Pre-rendered pages (scripts/prerender.ts) already contain the page's HTML
// for crawlers and first paint. That HTML is captured from a browser render,
// not React server rendering, so hydrateRoot() would report mismatches and
// re-render anyway; createRoot() replaces it cleanly on the first commit.
createRoot(container).render(app);